import {useTranslation} from "react-i18next";
import {Radio, RadioGroup, RadioGroupProps} from "../Radio/Radio";
import {Group} from "@mantine/core";

export type ReportTimeBasisRadioProps = Omit<RadioGroupProps, 'children'>

export const ReportTimeBasisRadio = (props: ReportTimeBasisRadioProps) => {
  const {...rest} = props;

  const {t} = useTranslation(["common"]);

  return (
    <RadioGroup{...rest}>
      <Group mt="xs">
        <Radio value="startShift" label={t<string>("common.entity.report.timebasis.startshift", "Start Shift")}/>
        <Radio value="endShift" label={t<string>("common.entity.report.timebasis.endshift", "End Shift")}/>
        <Radio value="transport" label={t<string>("common.entity.report.timebasis.transport", "Transport")}/>
      </Group>
    </RadioGroup>
  );
};
